
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lumgz", function(module, exports) {

$parcel$export(module.exports, "spaceForBaseSpaceQuery", () => $0b6a8bfd3c8020a4$export$10cb56c00ac59a8a);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $0b6a8bfd3c8020a4$export$10cb56c00ac59a8a = (0, $d2LG0.default)`query spaceForBaseSpaceQuery($spaceKey:String){spaces(spaceKey:$spaceKey){nodes{id key alias name homepage{id}icon{path width height isDefault}type settings{routeOverrideEnabled}theme{themeKey}lookAndFeel{headings{key value}menus{hoverOrFocus{key value}color}header{backgroundColor button{backgroundColor color}primaryNavigation{color hoverOrFocus{key value}}secondaryNavigation{color hoverOrFocus{key value}}search{backgroundColor color}}content{screen{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode layer{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode width height}gutterTop gutterRight gutterBottom gutterLeft}container{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}header{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}body{background backgroundColor backgroundImage backgroundPosition backgroundSize backgroundRepeat backgroundOrigin backgroundClip backgroundAttachment backgroundBlendMode padding borderRadius}}}metadata{labels{nodes{prefix name id}}}operations{operation targetType}}}}`;

});

parcelRegister("iqPBi", function(module, exports) {

$parcel$export(module.exports, "SpaceBase", () => $023f02fd9a9aead0$export$adbf61121b32bd9b);
/**
 * @graphql cc
 */ 
var $gwFzn = parcelRequire("gwFzn");

var $4y1GY = parcelRequire("4y1GY");

var $diswb = parcelRequire("diswb");

var $6qIXK = parcelRequire("6qIXK");

var $inPa6 = parcelRequire("inPa6");

var $dPJCf = parcelRequire("dPJCf");

var $lumgz = parcelRequire("lumgz");

var $1ytiN = parcelRequire("1ytiN");

var $fM6x5 = parcelRequire("fM6x5");

var $9wGTI = parcelRequire("9wGTI");

var $cEgMD = parcelRequire("cEgMD");

var $8oCjN = parcelRequire("8oCjN");

var $4b4iP = parcelRequire("4b4iP");
const $023f02fd9a9aead0$var$DISPLAY_ROOT = 'display';
const $023f02fd9a9aead0$var$SPACE_ROOT = 'spaces';
const $023f02fd9a9aead0$var$getUrlRoot = (pathname)=>{
    if (!pathname) return undefined;
    if (pathname.includes(`/${$023f02fd9a9aead0$var$SPACE_ROOT}/`)) return $023f02fd9a9aead0$var$SPACE_ROOT;
    else if (pathname.includes(`/${$023f02fd9a9aead0$var$DISPLAY_ROOT}/`)) return $023f02fd9a9aead0$var$DISPLAY_ROOT;
    else return undefined;
};
const $023f02fd9a9aead0$var$useContentSlug = (0, $dPJCf.createRouteParamHook)('contentSlug');
const $023f02fd9a9aead0$var$useContentId = (0, $dPJCf.createRouteParamHook)('contentId');
const $023f02fd9a9aead0$var$LegacySpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    const routeDataRef = (0, $dPJCf.useRouteDataRef)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { isAnonymous: isAnonymous } = (0, $gwFzn.useContext)((0, $1ytiN.SPAViewContext));
    const history = (0, $dPJCf.useHistory)();
    const isFirstRoute = history?.length === 1;
    const location = (0, $4y1GY.useLocation)();
    const fixSpaceEncodingInSpaceKey = ()=>{
        const pathname = location?.pathname || '';
        const decodedPathname = decodeURIComponent(pathname);
        if (// excludes the cases where there are no + symbols to replace at all
        // eg: /spaces/perfectly-fine-space-key
        pathname.indexOf('+') !== -1 && // excludes the cases where there is a + that follows the space key portion of the path
        // eg: /spaces/DS/other+stuff+that+contains+plus
        spaceKey.indexOf('+') !== -1 && // excludes the cases where the decoded path name still contains a + (from %2B)
        // , but the replacement to strip the + from the space key has already happened in previous SPA transition
        // eg: pathname = '/spaces/space%2Bkey', decodedPathname = '/spaces/space+key', spaceKey = 'space+key'
        decodedPathname.indexOf(`spaces/${spaceKey}`) !== -1) history?.replace?.({
            ...location,
            // Ensure we are replacing the "+" in the space key not other funny stuff
            pathname: decodedPathname.replace(`spaces/${spaceKey}`, `spaces/${spaceKey}`.replace(/\+/g, ' '))
        });
    };
    const removeEmailQueryParameters = ()=>{
        if (!location?.search?.includes('src=mail') && !location?.search?.includes('src.mail.')) return;
        let search = location?.search?.substring(1);
        const params = search.split('&').filter((param)=>!param.includes('src=mail') && !param.startsWith('src.mail.'));
        search = `?${params.join('&')}`;
        history?.replace?.({
            ...location,
            search: search
        });
    };
    (0, $gwFzn.useEffect)(()=>{
        fixSpaceEncodingInSpaceKey();
        removeEmailQueryParameters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        spaceKey
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (isSpaceLoading) return;
        if (space && space.alias && space.alias !== spaceKey) {
            const pathnameRoot = $023f02fd9a9aead0$var$getUrlRoot(location?.pathname);
            if (pathnameRoot) {
                const routeName = routeDataRef.current?.routeName || null;
                createAnalyticsEvent({
                    type: 'sendTrackEvent',
                    data: {
                        action: 'redirect',
                        actionSubject: 'route',
                        source: 'SpaceBase',
                        attributes: {
                            routeName: routeName,
                            // Space key related attributes.
                            areSpaceKeysEqualLowercase: space?.alias?.toLowerCase() === spaceKey?.toLowerCase()
                        }
                    }
                }).fire();
                history?.replace?.({
                    ...location,
                    pathname: location?.pathname?.replace(`/${pathnameRoot}/${spaceKey}`, `/${pathnameRoot}/${space.alias}`)
                });
            }
            return;
        }
    }, [
        createAnalyticsEvent,
        history,
        location,
        space,
        spaceKey,
        routeDataRef,
        isSpaceLoading
    ]);
    /*
   * Removing SpaceBaseThemedComponent for the Company Hub app-like experience at Team '25 US
   *
   * @see {@link https://www.figma.com/design/MBdUXhdmgbsIkMkOhQGu5e/Hub-App?node-id=101-52260}
   * @see {@link https://hello.atlassian.net/wiki/spaces/CLI/pages/4856024337/Confluence-less+Team+25+US+Experience}
   */ const SpaceBaseWrapper = (0, $cEgMD.isCompanyHubSpaceKey)(spaceKey) && (0, $9wGTI.fg)('company-hub-pseudo-app') ? (0, $gwFzn.Fragment) : (0, $8oCjN.SpaceBaseThemedComponent);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4b4iP.SpaceRestrictionHandler), {
        spaceKey: spaceKey,
        isAnonymous: isAnonymous,
        contentId: contentId,
        isFirstRoute: isFirstRoute,
        goBackPreviousPage: history?.goBack
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
        "data-testid": "space-base-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, (/*@__PURE__*/$parcel$interopDefault($6qIXK)))({
            'wrapper-space-view-page': isViewPage,
            'wrapper-space-home-page': !isViewPage
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(SpaceBaseWrapper, null, children)));
};
const $023f02fd9a9aead0$var$SpaceBaseComponent = ({ children: children, spaceKey: spaceKey, space: space, isSpaceLoading: isSpaceLoading })=>{
    const contentId = $023f02fd9a9aead0$var$useContentId();
    const contentSlug = $023f02fd9a9aead0$var$useContentSlug();
    const isViewPage = !!contentId || !!contentSlug;
    return $023f02fd9a9aead0$var$LegacySpaceBaseComponent({
        children: children,
        spaceKey: spaceKey,
        space: space,
        isSpaceLoading: isSpaceLoading
    });
};
const $023f02fd9a9aead0$var$useSpaceKey = (0, $dPJCf.createRouteParamHook)('spaceKey');
const $023f02fd9a9aead0$export$adbf61121b32bd9b = ({ children: children, spaceKey: spaceKey })=>{
    const resolvedSpaceKey = $023f02fd9a9aead0$var$useSpaceKey() || spaceKey || '';
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Probably preloaded
    (0, $lumgz.spaceForBaseSpaceQuery), {
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        skip: Boolean(undefined),
        variables: {
            spaceKey: resolvedSpaceKey
        }
    });
    // clear out the space if there is an error
    const space = error && !loading ? null : data?.spaces?.nodes?.[0];
    return (0, $fM6x5.default)(()=>space?.name)($023f02fd9a9aead0$var$SpaceBaseComponent)({
        spaceKey: resolvedSpaceKey,
        space: space,
        children: children,
        isSpaceLoading: loading
    });
};

});
parcelRegister("fM6x5", function(module, exports) {

$parcel$export(module.exports, "default", () => $6436abe84fc91b7d$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $8EsbU = parcelRequire("8EsbU");

var $d5RCH = parcelRequire("d5RCH");
function $6436abe84fc91b7d$export$2e2bcd8739ae039(getTitle, wrapperStyle) {
    if (typeof wrapperStyle === 'undefined') wrapperStyle = {};
    return (BaseComponent)=>(props)=>{
            const title = getTitle(props);
            const siteTitle = (0, $8EsbU.getOverride)('site-title') || '';
            const titleDefinedOnWindow = window['__DOCUMENT_TITLE_TAG__'] || '';
            let titleProp;
            if (titleDefinedOnWindow) titleProp = titleDefinedOnWindow;
            else if (title && siteTitle) titleProp = `${title} - ${siteTitle}`;
            else titleProp = title || siteTitle;
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("div", {
                style: wrapperStyle,
                "data-testid": "with-document-title"
            }, !window['__SSR_RENDERED__'] && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $d5RCH.PageTitle), {
                title: titleProp
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement(BaseComponent, props)));
        };
}

});

parcelRegister("8oCjN", function(module, exports) {

$parcel$export(module.exports, "SpaceBaseThemedComponent", () => $7bbee5da9ba28ec8$export$7f576b861c4a75d4);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $lKNXy = parcelRequire("lKNXy");

var $lpxTx = parcelRequire("lpxTx");
var $61vTv = parcelRequire("61vTv");

var $7zgzO = parcelRequire("7zgzO");

var $ep3mz = parcelRequire("ep3mz");

var $1NBp8 = parcelRequire("1NBp8");

var $3Klda = parcelRequire("3Klda");

var $5ZqQS = parcelRequire("5ZqQS");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $fyPYm = parcelRequire("fyPYm");

var $kmaxw = parcelRequire("kmaxw");
const $7bbee5da9ba28ec8$var$connectAddonContainerStyle = {
    position: 'relative'
};
const $7bbee5da9ba28ec8$var$connectAddonProps = {
    contentStyle: {
        width: '100%',
        textAlign: 'center',
        display: 'inline-block'
    },
    width: '100%',
    height: '100%'
};
const $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX = /^ac:(.*)__(.*)-remote-theme$/;
const $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7 = (themeKey)=>{
    const regexResult = $7bbee5da9ba28ec8$var$SPACE_THEME_KEY_MODULE_KEY_REGEX.exec(themeKey);
    return regexResult ? [
        regexResult[1],
        regexResult[2]
    ] : [
        null,
        null
    ];
};
const $7bbee5da9ba28ec8$export$7f576b861c4a75d4 = ({ children: children })=>{
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const [contentType] = (0, $ep3mz.useContentType)();
    let chooseContentUnifiedQuery = (0, $61vTv.ContentUnifiedQuery);
    if (contentType === 'blogpost') chooseContentUnifiedQuery = (0, $lpxTx.ContentBlogUnifiedQuery);
    const isSpaceOverview = match?.name === (0, $1NBp8.SPACE_OVERVIEW).name;
    const skipContentQuery = !contentId || !spaceKey || !isSpaceOverview || contentIdLoading;
    const contentQueryResult = (0, $diswb.useQuery)(chooseContentUnifiedQuery, {
        context: {
            single: true
        },
        variables: {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: null,
            useNewContentTopper: true
        },
        skip: skipContentQuery
    });
    const themeKey = contentQueryResult?.data?.space?.theme?.themeKey;
    const routeOverrideEnabled = contentQueryResult?.data?.space?.settings?.routeOverrideEnabled;
    const [themeAddonKey, themeModuleKey] = $7bbee5da9ba28ec8$export$3d1ab4d62a569dc7(themeKey);
    const skipOverrideQuery = !themeAddonKey || !themeModuleKey || !routeOverrideEnabled;
    const overrideQueryResult = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $kmaxw.ExperimentalThemeSpaceHomeOverrideQuery), {
        variables: {
            themeAddonKey: themeAddonKey,
            themeModuleKey: themeModuleKey,
            spaceKey: spaceKey,
            spaceHomePageId: contentId
        },
        skip: skipOverrideQuery
    });
    if (contentQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(contentQueryResult.error, {
            attribution: (0, $dIouf.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(contentQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    }
    if (overrideQueryResult.error) {
        (0, $5ZqQS.getMonitoringClient)().submitError(overrideQueryResult.error, {
            attribution: (0, $dIouf.Attribution).ECOSYSTEM
        });
        (0, $7Sm4c.markErrorAsHandled)(overrideQueryResult.error);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    }
    if (contentIdLoading) return null;
    if (skipContentQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    if (contentQueryResult.loading || !skipOverrideQuery && overrideQueryResult.loading) return null;
    if (skipOverrideQuery) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    if (!contentQueryResult.data || !overrideQueryResult.data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    const { hasSpaceHomeOverride: hasSpaceHomeOverride, spaceHomeOverrideDescriptor: spaceHomeOverrideDescriptor } = overrideQueryResult.data.experimentalThemeSpaceHomeOverride;
    if (!hasSpaceHomeOverride) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, children);
    spaceHomeOverrideDescriptor.productContext = JSON.parse(spaceHomeOverrideDescriptor.productCtx);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $3Klda.ContentScreenBackgroundLayer), {
        lookAndFeel: contentQueryResult?.data?.space?.lookAndFeel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lKNXy.ConnectAddon), {
        containerStyle: $7bbee5da9ba28ec8$var$connectAddonContainerStyle,
        descriptor: spaceHomeOverrideDescriptor,
        ...$7bbee5da9ba28ec8$var$connectAddonProps
    }), isSpaceOverview && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fyPYm.ContentViewedEvent), {
        contentId: contentId
    }));
};

});
parcelRegister("kmaxw", function(module, exports) {

$parcel$export(module.exports, "ExperimentalThemeSpaceHomeOverrideQuery", () => $301cd5cfa500762a$export$d9b1e55f2ab777a5);

var $d2LG0 = parcelRequire("d2LG0");
const $301cd5cfa500762a$export$d9b1e55f2ab777a5 = (0, $d2LG0.default)`query ExperimentalThemeSpaceHomeOverrideQuery($themeAddonKey:String$themeModuleKey:String$spaceKey:String!$spaceHomePageId:String!)@experimental{experimentalThemeSpaceHomeOverride(themeAddonKey:$themeAddonKey themeModuleKey:$themeModuleKey spaceKey:$spaceKey spaceHomePageId:$spaceHomePageId){hasSpaceHomeOverride spaceHomeOverrideDescriptor{addon_key apiMigrations{gdpr}contentClassifier contextJwt cp general h hostOrigin key moduleType origin productCtx sandbox structuredContext timeZone uniqueKey url w}}}`;

});


parcelRegister("4b4iP", function(module, exports) {

$parcel$export(module.exports, "SpaceRestrictionHandler", () => $343989ced147f5e6$export$20a459334853e190);

var $gwFzn = parcelRequire("gwFzn");

var $67Foi = parcelRequire("67Foi");

var $hPAXP = parcelRequire("hPAXP");

var $fG32j = parcelRequire("fG32j");

var $aZfd8 = parcelRequire("aZfd8");
const $343989ced147f5e6$export$20a459334853e190 = ({ children: children, spaceKey: spaceKey, isAnonymous: isAnonymous = false, contentId: contentId, isFirstRoute: isFirstRoute = false, goBackPreviousPage: goBackPreviousPage })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $fG32j.SpaceRestrictionCheck), {
        spaceKey: spaceKey
    }, ({ isSpaceRestricted: isSpaceRestricted, isSpaceNotFound: isSpaceNotFound })=>{
        if (isSpaceRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hPAXP.RestrictedSpace), {
            goToPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute,
            contentId: contentId
        });
        if (isSpaceNotFound && !isAnonymous && !contentId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $aZfd8.Space404), {
            goBackPreviousPage: goBackPreviousPage,
            isFirstRoute: isFirstRoute
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $67Foi.ScreenEvent), {
            name: "spaceNotFoundScreen",
            id: spaceKey
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, children);
    });
};

});
parcelRegister("aZfd8", function(module, exports) {

$parcel$export(module.exports, "Space404", () => $c70a78199cd90f84$export$a506b89ee82dfeb8);

var $gwFzn = parcelRequire("gwFzn");

var $4jR19 = parcelRequire("4jR19");

var $gllul = parcelRequire("gllul");
const $c70a78199cd90f84$export$a506b89ee82dfeb8 = (props)=>{
    const { isFirstRoute: isFirstRoute, goBackPreviousPage: goBackPreviousPage } = props;
    const onClickGoPreviousLink = (e)=>{
        e.preventDefault();
        if (goBackPreviousPage) goBackPreviousPage();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gllul.NotFound), {
        secondaryButtonProps: {
            children: !isFirstRoute && goBackPreviousPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
                id: "space-404.text.go.back.previous.page",
                defaultMessage: "Go to previous page"
            }),
            onClick: onClickGoPreviousLink
        }
    });
};
$c70a78199cd90f84$export$a506b89ee82dfeb8.displayName = 'Space404';

});



parcelRegister("iqZzD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6ba6afbc5717c4a$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $iqPBi = parcelRequire("iqPBi");
var $d6ba6afbc5717c4a$export$2e2bcd8739ae039 = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iqPBi.SpaceBase), props);
};

});

parcelRegister("f5aR2", function(module, exports) {

$parcel$export(module.exports, "ContentExtensionsProvider", () => $cc34c55db5a1bcbb$export$2a88d3b468decd4a);

var $gwFzn = parcelRequire("gwFzn");

var $7okiz = parcelRequire("7okiz");

var $69aHU = parcelRequire("69aHU");

var $hMRhJ = parcelRequire("hMRhJ");

var $jFmKg = parcelRequire("jFmKg");

const $cc34c55db5a1bcbb$var$getLegacyContentExtensions = ()=>({
        loadSortableTable: ()=>(parcelRequire("ksEBw"))
    });
const $cc34c55db5a1bcbb$var$providers = {
    getExtensionHandlers: $7okiz.getExtensionHandlers,
    getLegacyContentExtensions: $cc34c55db5a1bcbb$var$getLegacyContentExtensions,
    populateExtensionProviders: $69aHU.populateExtensionProviders,
    EditorLoaderLoader: $jFmKg.default
};
const $cc34c55db5a1bcbb$export$2a88d3b468decd4a = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hMRhJ.RendererExtensionContext).Provider, {
        value: $cc34c55db5a1bcbb$var$providers
    }, children);

});
parcelRegister("ksEBw", function(module, exports) {

let $ee55eb4c4f13c236$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $ee55eb4c4f13c236$var$load("kuPgl").then(()=>parcelRequire('5byen'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("4H46k", function(module, exports) {

$parcel$export(module.exports, "LazySpaceBlogRedirect", () => $36ae5bfcf92491af$export$2f32c75fff716fcc);
$parcel$export(module.exports, "LazySpaceEditPage", () => $36ae5bfcf92491af$export$d7b87d306b5def2c);
$parcel$export(module.exports, "LazySpaceCreatePage", () => $36ae5bfcf92491af$export$5590c410e7d0a293);
$parcel$export(module.exports, "LazyRouteToRightEditor", () => $36ae5bfcf92491af$export$325f108b642b51d);
$parcel$export(module.exports, "LazyMobileWebContainer", () => $36ae5bfcf92491af$export$e650af616d3a92cf);
$parcel$export(module.exports, "LazyDwellTime", () => $36ae5bfcf92491af$export$dcf40c4d983a3b1f);
$parcel$export(module.exports, "LazySendConsumptionViewedAndCompletedEvent", () => $36ae5bfcf92491af$export$a23eb3879aeccdfd);
$parcel$export(module.exports, "LazyConfluenceNotFound", () => $36ae5bfcf92491af$export$33256e23669f7955);
$parcel$export(module.exports, "LazyTeamCalendars", () => $36ae5bfcf92491af$export$666c7163d0ae1b3f);
$parcel$export(module.exports, "LazyQuestions", () => $36ae5bfcf92491af$export$aeb070a9ba92094e);
$parcel$export(module.exports, "LazyJiraProjectBoard", () => $36ae5bfcf92491af$export$b91db2a8ae520395);
// These exports are using the .default prop of the module because we're mixing ES6 and ES5. This is required for
// webpack to be able to correctly split bundles.

var $jmjWc = parcelRequire("jmjWc");

const $36ae5bfcf92491af$export$2f32c75fff716fcc = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "b7m6n",
    name: "LazySpaceBlogRedirect",
    loader: async ()=>(await (parcelRequire("ffqoj"))).SpaceBlogRedirect
});

const $36ae5bfcf92491af$export$d7b87d306b5def2c = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "z-U-s",
    name: "LazySpaceEditPage",
    loader: ()=>(parcelRequire("rVyWY"))
});

const $36ae5bfcf92491af$export$5590c410e7d0a293 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "LfHUf",
    name: "LazySpaceCreatePage",
    loader: ()=>(parcelRequire("fSash"))
});

const $36ae5bfcf92491af$export$325f108b642b51d = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "91GWy",
    name: "LazyRouteToRightEditor",
    loader: ()=>(parcelRequire("3gswZ"))
});

const $36ae5bfcf92491af$export$e650af616d3a92cf = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "Z1eTA",
    name: "LazyMobileWebContainer",
    loader: ()=>(parcelRequire("4HG2K"))
});

const $36ae5bfcf92491af$export$dcf40c4d983a3b1f = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "TnNDX",
    name: "LazyDwellTime",
    loader: ()=>(parcelRequire("imuhR"))
});

const $36ae5bfcf92491af$export$a23eb3879aeccdfd = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "taQD2",
    name: "LazySendConsumptionViewedAndCompletedEvent",
    loader: async ()=>(await (parcelRequire("6bmvl"))).SendConsumptionViewedAndCompletedEvent
});

const $36ae5bfcf92491af$export$33256e23669f7955 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AaHry",
    name: "LazyConfluenceNotFound",
    loader: ()=>(parcelRequire("4n6Pr"))
});

const $36ae5bfcf92491af$export$666c7163d0ae1b3f = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "ZAbLZ",
    name: "LazyTeamCalendars",
    loader: async ()=>(await (parcelRequire("3fDXc"))).TeamCalendar
});

const $36ae5bfcf92491af$export$aeb070a9ba92094e = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "YG4Pa",
    name: "LazyQuestions",
    loader: async ()=>(await (parcelRequire("cRrwi"))).Questions
});

const $36ae5bfcf92491af$export$b91db2a8ae520395 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "IIGIO",
    name: "LazyJiraProjectBoard",
    loader: async ()=>(await (parcelRequire("fE74J"))).JiraProjectBoard
});

});
parcelRegister("ffqoj", function(module, exports) {

let $b19cba74273d2c26$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("1PDLq"), 5)),
    $b19cba74273d2c26$var$load("dqnQo")
]).then(()=>parcelRequire('iT775'));

});
parcelRegister("di5rn", function(module, exports) {
"use strict";

var $jDpSy = parcelRequire("jDpSy");
module.exports = $jDpSy(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        let existingLinks = document.getElementsByTagName('link');
        if ([].concat(existingLinks).some(function(link) {
            return link.href === bundle && link.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("jDpSy", function(module, exports) {
"use strict";
let $e4b5bbdb98dce921$var$cachedBundles = {};
let $e4b5bbdb98dce921$var$cachedPreloads = {};
let $e4b5bbdb98dce921$var$cachedPrefetches = {};
function $e4b5bbdb98dce921$var$getCache(type) {
    switch(type){
        case 'preload':
            return $e4b5bbdb98dce921$var$cachedPreloads;
        case 'prefetch':
            return $e4b5bbdb98dce921$var$cachedPrefetches;
        default:
            return $e4b5bbdb98dce921$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        let cache = $e4b5bbdb98dce921$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("rVyWY", function(module, exports) {

let $053f2c7ca131ab13$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("73iD8"), 5)),
    $053f2c7ca131ab13$var$load("lMmk5"),
    $053f2c7ca131ab13$var$load("gZKQW"),
    $053f2c7ca131ab13$var$load("7rEYM"),
    $053f2c7ca131ab13$var$load("43hsF"),
    $053f2c7ca131ab13$var$load("i27dG"),
    $053f2c7ca131ab13$var$load("jycv9"),
    $053f2c7ca131ab13$var$load("iFwd1")
]).then(()=>parcelRequire('hyHUM'));

});

parcelRegister("fSash", function(module, exports) {

let $b8e40254518a33f1$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("6Owk1"), 5)),
    $b8e40254518a33f1$var$load("lMmk5"),
    $b8e40254518a33f1$var$load("gZKQW"),
    $b8e40254518a33f1$var$load("7rEYM"),
    $b8e40254518a33f1$var$load("43hsF"),
    $b8e40254518a33f1$var$load("i27dG"),
    $b8e40254518a33f1$var$load("jycv9"),
    $b8e40254518a33f1$var$load("2xeoE")
]).then(()=>parcelRequire('3ajXc'));

});

parcelRegister("3gswZ", function(module, exports) {

let $2608ff6564c64f3b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $2608ff6564c64f3b$var$load("5oUQI").then(()=>parcelRequire('lx9c3'));

});

parcelRegister("4HG2K", function(module, exports) {

let $36cbca7d3af41fdb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $36cbca7d3af41fdb$var$load("jycv9"),
    $36cbca7d3af41fdb$var$load("XfwMA")
]).then(()=>parcelRequire('hKxxO'));

});

parcelRegister("imuhR", function(module, exports) {

let $d5e1c66f0e3bc70b$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $d5e1c66f0e3bc70b$var$load("3g3yi").then(()=>parcelRequire('bBPzK'));

});

parcelRegister("6bmvl", function(module, exports) {

let $48053a1b96584493$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $48053a1b96584493$var$load("fvv3N").then(()=>parcelRequire('11i6T'));

});

parcelRegister("4n6Pr", function(module, exports) {

let $32ee9b77e9f476b5$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $32ee9b77e9f476b5$var$load("jycv9").then(()=>parcelRequire('hxzAh'));

});

parcelRegister("3fDXc", function(module, exports) {

let $25e1c3ce51a8d10e$var$load = (parcelRequire("lhnSv"))(5);



module.exports = Promise.all([
    (parcelRequire("di5rn"))((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve("3g2Oe"), 5)),
    $25e1c3ce51a8d10e$var$load("5oU5X"),
    $25e1c3ce51a8d10e$var$load("e1HLH"),
    $25e1c3ce51a8d10e$var$load("7WcBh"),
    $25e1c3ce51a8d10e$var$load("ipK41"),
    $25e1c3ce51a8d10e$var$load("3TNOq"),
    $25e1c3ce51a8d10e$var$load("2Fobu"),
    $25e1c3ce51a8d10e$var$load("6qah4"),
    $25e1c3ce51a8d10e$var$load("buSZn")
]).then(()=>parcelRequire('2ZK7m'));

});

parcelRegister("cRrwi", function(module, exports) {

let $95cfc820e757ac7a$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $95cfc820e757ac7a$var$load("a1ZNF"),
    $95cfc820e757ac7a$var$load("aotZe"),
    $95cfc820e757ac7a$var$load("Gv0NT"),
    $95cfc820e757ac7a$var$load("afozL"),
    $95cfc820e757ac7a$var$load("1LhCD"),
    $95cfc820e757ac7a$var$load("44W0y"),
    $95cfc820e757ac7a$var$load("iV231"),
    $95cfc820e757ac7a$var$load("l4ZLl"),
    $95cfc820e757ac7a$var$load("ftgqK"),
    $95cfc820e757ac7a$var$load("jrNlW"),
    $95cfc820e757ac7a$var$load("1ugoC"),
    $95cfc820e757ac7a$var$load("hJ5qg"),
    $95cfc820e757ac7a$var$load("boDjZ"),
    $95cfc820e757ac7a$var$load("7l3QW"),
    $95cfc820e757ac7a$var$load("26Id4"),
    $95cfc820e757ac7a$var$load("2FQDC"),
    $95cfc820e757ac7a$var$load("gsILB"),
    $95cfc820e757ac7a$var$load("6Zezm"),
    $95cfc820e757ac7a$var$load("emd3r"),
    $95cfc820e757ac7a$var$load("chR0R"),
    $95cfc820e757ac7a$var$load("gzdCt"),
    $95cfc820e757ac7a$var$load("15APZ"),
    $95cfc820e757ac7a$var$load("bzjLG"),
    $95cfc820e757ac7a$var$load("2RgZK"),
    $95cfc820e757ac7a$var$load("c6MKV"),
    $95cfc820e757ac7a$var$load("6qah4"),
    $95cfc820e757ac7a$var$load("aZinD"),
    $95cfc820e757ac7a$var$load("6UnNI"),
    $95cfc820e757ac7a$var$load("4GuoO")
]).then(()=>parcelRequire('a6Tu8'));

});

parcelRegister("fE74J", function(module, exports) {

let $b64014765817d9e2$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $b64014765817d9e2$var$load("ej4rO"),
    $b64014765817d9e2$var$load("18vkH"),
    $b64014765817d9e2$var$load("2w2Fa"),
    $b64014765817d9e2$var$load("9QvHa"),
    $b64014765817d9e2$var$load("3ooAX"),
    $b64014765817d9e2$var$load("4lfDj"),
    $b64014765817d9e2$var$load("kUAIU"),
    $b64014765817d9e2$var$load("dTsOE"),
    $b64014765817d9e2$var$load("2RgZK"),
    $b64014765817d9e2$var$load("hRUJD")
]).then(()=>parcelRequire('dYnWI'));

});


parcelRegister("6Evf5", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d7eb68e35a8590f$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $diswb = parcelRequire("diswb");

var $ep3mz = parcelRequire("ep3mz");

var $hl1Kw = parcelRequire("hl1Kw");

var $3GP6F = parcelRequire("3GP6F");

var $9LzHv = parcelRequire("9LzHv");

var $iAoZQ = parcelRequire("iAoZQ");
const $4d7eb68e35a8590f$var$dayInMilliseconds = 86400000; // hours*minutes*seconds*milliseconds
const $4d7eb68e35a8590f$var$NO_DATE_DEFINED = -1;
const $4d7eb68e35a8590f$var$ARCHIVED = 'archived';
const $4d7eb68e35a8590f$export$10ab27af88aafb56 = (pastDateStr, currentDate = new Date())=>{
    const pastDate = new Date(pastDateStr);
    // days since creation
    return Math.round((currentDate.getTime() - pastDate.getTime()) / $4d7eb68e35a8590f$var$dayInMilliseconds);
};
const $4d7eb68e35a8590f$var$_getDaysSinceCreated = (node)=>{
    const createdDateStr = node?.history?.createdDate;
    return createdDateStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(createdDateStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$var$_getDaysSinceUpdated = (node)=>{
    const lastUpdatedStr = node?.history?.lastUpdated?.when;
    return lastUpdatedStr ? $4d7eb68e35a8590f$export$10ab27af88aafb56(lastUpdatedStr) : $4d7eb68e35a8590f$var$NO_DATE_DEFINED;
};
const $4d7eb68e35a8590f$export$f8668f0d8d89d19c = (currentDate = new Date())=>{
    const hours = currentDate.getHours();
    return hours >= 15 && hours <= 23;
};
const $4d7eb68e35a8590f$export$35de754c0b3b58bd = ()=>{
    if (document && document.visibilityState) return document.visibilityState;
    return 'unset';
};
const $4d7eb68e35a8590f$var$SendTrackViewPageEvent = ({ pageType: pageType, source: source })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [{ searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics }] = (0, $hl1Kw.useSearchSessionId)();
    const featureCodes = (0, $3GP6F.useFeatureCodesInURL)();
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)((0, $iAoZQ.SendTrackViewPageEventQuery), {
        variables: {
            contentId: contentId
        }
    });
    const space = data?.content?.nodes?.[0]?.space;
    const fabricEditorSupported = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorSupported;
    const fabricEditorEligibility = data?.content?.nodes?.[0]?.metadata?.frontend?.fabricEditorEligibility;
    if (error || loading || !space) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9LzHv.default), {
        action: "viewed",
        actionSubject: "page",
        source: source,
        containerType: "space",
        containerId: space.id,
        objectType: "page",
        objectId: contentId,
        attributes: {
            pageType: pageType,
            daysSinceCreated: $4d7eb68e35a8590f$var$_getDaysSinceCreated(data.content.nodes[0]),
            daysSinceModified: $4d7eb68e35a8590f$var$_getDaysSinceUpdated(data.content.nodes[0]),
            searchReferrer: searchSessionId,
            ...additionalAnalytics,
            isArchivedPage: data.content.nodes[0].status === $4d7eb68e35a8590f$var$ARCHIVED,
            viewedScreenAfter3PM: $4d7eb68e35a8590f$export$f8668f0d8d89d19c(),
            pageVisibility: $4d7eb68e35a8590f$export$35de754c0b3b58bd(),
            fabricEditorEligibility: fabricEditorEligibility,
            fabricEditorSupported: fabricEditorSupported,
            ...featureCodes && featureCodes.from ? {
                from: featureCodes.from
            } : {}
        }
    });
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.propTypes = {
    pageType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOf([
        'page',
        'blogpost'
    ]),
    source: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).oneOf([
        'viewPageScreen',
        'mobileWebView'
    ])
};
$4d7eb68e35a8590f$var$SendTrackViewPageEvent.defaultProps = {
    source: 'viewPageScreen'
};
var $4d7eb68e35a8590f$export$2e2bcd8739ae039 = $4d7eb68e35a8590f$var$SendTrackViewPageEvent;

});
parcelRegister("9LzHv", function(module, exports) {

$parcel$export(module.exports, "default", () => $71c43243f3d11279$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");

var $fppBw = parcelRequire("fppBw");

var $1DWH0 = parcelRequire("1DWH0");
const $71c43243f3d11279$var$sendTrackEvent = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = props;
    const analyticsData = {
        action: props.action,
        actionSubject: props.actionSubject,
        attributes: props.attributes,
        containerId: props.containerId,
        containerType: props.containerType,
        objectId: props.objectId,
        objectType: props.objectType,
        source: props.source
    };
    const analyticsEvent = createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: analyticsData
    });
    analyticsEvent.fire();
};
function $71c43243f3d11279$var$SendTrackEventComponent(props) {
    const { action: action, actionSubject: actionSubject, attributes: attributes, containerId: containerId, containerType: containerType, objectId: objectId, objectType: objectType, source: source } = props;
    (0, $gwFzn.useEffect)(()=>{
        $71c43243f3d11279$var$sendTrackEvent(props);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        action,
        actionSubject,
        attributes,
        containerId,
        containerType,
        objectId,
        objectType,
        source
    ]);
    return null;
}
$71c43243f3d11279$var$SendTrackEventComponent.propTypes = {
    action: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    actionSubject: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    attributes: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).object,
    containerId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    containerType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    objectId: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    objectType: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    source: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).string.isRequired,
    createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($fppBw))).func.isRequired
};
$71c43243f3d11279$var$SendTrackEventComponent.defaultProps = {
    attributes: {}
};
var $71c43243f3d11279$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($71c43243f3d11279$var$SendTrackEventComponent);

});

parcelRegister("iAoZQ", function(module, exports) {

$parcel$export(module.exports, "SendTrackViewPageEventQuery", () => $d87efa95de2d7c4b$export$891b2cd76733e577);

var $d2LG0 = parcelRequire("d2LG0");
const $d87efa95de2d7c4b$export$891b2cd76733e577 = (0, $d2LG0.default)`query SendTrackViewPageEventQuery($contentId:ID){content(id:$contentId){nodes{id history{createdDate lastUpdated{when}}metadata{frontend{fabricEditorSupported fabricEditorEligibility}}space{id}status}}}`;

});


parcelRegister("480xA", function(module, exports) {

$parcel$export(module.exports, "EmbeddedViewPageLoader", () => $d81ad828f72fdf38$export$3717da370a5be6bc);
$parcel$export(module.exports, "EmbeddedEditPageLoader", () => $d81ad828f72fdf38$export$a835caedc175b18);
$parcel$export(module.exports, "EmbeddedWhiteboardLoader", () => $d81ad828f72fdf38$export$eaeb91b7cf6d3df6);

var $jmjWc = parcelRequire("jmjWc");

const $d81ad828f72fdf38$export$3717da370a5be6bc = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "jHvmi",
    name: "EmbeddedViewPageLoader",
    loader: async ()=>(await (parcelRequire("lHWxI"))).EmbeddedViewPage
});

const $d81ad828f72fdf38$export$a835caedc175b18 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "BMGOy",
    name: "EmbeddedEditPageLoader",
    loader: async ()=>(await (parcelRequire("03TZF"))).EmbeddedEditPage
});

const $d81ad828f72fdf38$export$eaeb91b7cf6d3df6 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "wHmJ5",
    name: "EmbeddedWhiteboardLoader",
    loader: async ()=>(await (parcelRequire("ksx2M"))).EmbeddedWhiteboard
});

});
parcelRegister("lHWxI", function(module, exports) {

let $fcdb067f7fea67fd$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $fcdb067f7fea67fd$var$load("K63aN"),
    $fcdb067f7fea67fd$var$load("cCMme"),
    $fcdb067f7fea67fd$var$load("bmRjE"),
    $fcdb067f7fea67fd$var$load("lkImb"),
    $fcdb067f7fea67fd$var$load("gQ63a"),
    $fcdb067f7fea67fd$var$load("b886X"),
    $fcdb067f7fea67fd$var$load("jrNlW"),
    $fcdb067f7fea67fd$var$load("boDjZ"),
    $fcdb067f7fea67fd$var$load("7l3QW"),
    $fcdb067f7fea67fd$var$load("26Id4"),
    $fcdb067f7fea67fd$var$load("2FQDC"),
    $fcdb067f7fea67fd$var$load("gsILB"),
    $fcdb067f7fea67fd$var$load("6Zezm"),
    $fcdb067f7fea67fd$var$load("7Y2NJ"),
    $fcdb067f7fea67fd$var$load("732y6"),
    $fcdb067f7fea67fd$var$load("aPhLY"),
    $fcdb067f7fea67fd$var$load("emd3r"),
    $fcdb067f7fea67fd$var$load("hOsvD"),
    $fcdb067f7fea67fd$var$load("3TNOq"),
    $fcdb067f7fea67fd$var$load("eCgOQ"),
    $fcdb067f7fea67fd$var$load("ipTFT"),
    $fcdb067f7fea67fd$var$load("15APZ"),
    $fcdb067f7fea67fd$var$load("bzjLG"),
    $fcdb067f7fea67fd$var$load("2RgZK"),
    $fcdb067f7fea67fd$var$load("6qah4"),
    $fcdb067f7fea67fd$var$load("6UnNI"),
    $fcdb067f7fea67fd$var$load("c6MKV"),
    $fcdb067f7fea67fd$var$load("aZinD"),
    $fcdb067f7fea67fd$var$load("cyGuT"),
    $fcdb067f7fea67fd$var$load("WXYxI")
]).then(()=>parcelRequire('6N2H2'));

});

parcelRegister("03TZF", function(module, exports) {

let $00bbb71eb38d9124$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $00bbb71eb38d9124$var$load("a1ZNF"),
    $00bbb71eb38d9124$var$load("aotZe"),
    $00bbb71eb38d9124$var$load("afozL"),
    $00bbb71eb38d9124$var$load("hKW6J"),
    $00bbb71eb38d9124$var$load("iV231"),
    $00bbb71eb38d9124$var$load("l4ZLl"),
    $00bbb71eb38d9124$var$load("1ugoC"),
    $00bbb71eb38d9124$var$load("hJ5qg"),
    $00bbb71eb38d9124$var$load("boDjZ"),
    $00bbb71eb38d9124$var$load("7l3QW"),
    $00bbb71eb38d9124$var$load("26Id4"),
    $00bbb71eb38d9124$var$load("2FQDC"),
    $00bbb71eb38d9124$var$load("gsILB"),
    $00bbb71eb38d9124$var$load("1jn79"),
    $00bbb71eb38d9124$var$load("6Zezm"),
    $00bbb71eb38d9124$var$load("emd3r"),
    $00bbb71eb38d9124$var$load("gzdCt"),
    $00bbb71eb38d9124$var$load("15APZ"),
    $00bbb71eb38d9124$var$load("bzjLG"),
    $00bbb71eb38d9124$var$load("2RgZK"),
    $00bbb71eb38d9124$var$load("6qah4"),
    $00bbb71eb38d9124$var$load("6wlp3"),
    $00bbb71eb38d9124$var$load("c6MKV"),
    $00bbb71eb38d9124$var$load("aZinD"),
    $00bbb71eb38d9124$var$load("cyGuT"),
    $00bbb71eb38d9124$var$load("aHCaB"),
    $00bbb71eb38d9124$var$load("aPhLY"),
    $00bbb71eb38d9124$var$load("eCgOQ"),
    $00bbb71eb38d9124$var$load("3Kg3S"),
    $00bbb71eb38d9124$var$load("lwNze")
]).then(()=>parcelRequire('dJsyi'));

});

parcelRegister("ksx2M", function(module, exports) {

let $ee500dfabeb5b9cb$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $ee500dfabeb5b9cb$var$load("fGDbf"),
    $ee500dfabeb5b9cb$var$load("1duYE"),
    $ee500dfabeb5b9cb$var$load("gAIhR"),
    $ee500dfabeb5b9cb$var$load("dsDqI"),
    $ee500dfabeb5b9cb$var$load("lkImb"),
    $ee500dfabeb5b9cb$var$load("gQ63a"),
    $ee500dfabeb5b9cb$var$load("b886X"),
    $ee500dfabeb5b9cb$var$load("jrNlW"),
    $ee500dfabeb5b9cb$var$load("boDjZ"),
    $ee500dfabeb5b9cb$var$load("7l3QW"),
    $ee500dfabeb5b9cb$var$load("26Id4"),
    $ee500dfabeb5b9cb$var$load("2FQDC"),
    $ee500dfabeb5b9cb$var$load("gsILB"),
    $ee500dfabeb5b9cb$var$load("6Zezm"),
    $ee500dfabeb5b9cb$var$load("732y6"),
    $ee500dfabeb5b9cb$var$load("aPhLY"),
    $ee500dfabeb5b9cb$var$load("emd3r"),
    $ee500dfabeb5b9cb$var$load("hOsvD"),
    $ee500dfabeb5b9cb$var$load("3TNOq"),
    $ee500dfabeb5b9cb$var$load("eCgOQ"),
    $ee500dfabeb5b9cb$var$load("ipTFT"),
    $ee500dfabeb5b9cb$var$load("15APZ"),
    $ee500dfabeb5b9cb$var$load("bzjLG"),
    $ee500dfabeb5b9cb$var$load("2RgZK"),
    $ee500dfabeb5b9cb$var$load("6qah4"),
    $ee500dfabeb5b9cb$var$load("6UnNI"),
    $ee500dfabeb5b9cb$var$load("c6MKV"),
    $ee500dfabeb5b9cb$var$load("aZinD"),
    $ee500dfabeb5b9cb$var$load("cyGuT"),
    $ee500dfabeb5b9cb$var$load("le4u8")
]).then(()=>parcelRequire('gG2kN'));

});


parcelRegister("9pOEz", function(module, exports) {

$parcel$export(module.exports, "CommentContextWrapper", () => $1adfb96e71037064$export$1d04f0e8aa57d594);

var $gwFzn = parcelRequire("gwFzn");

var $9jl6v = parcelRequire("9jl6v");
const $1adfb96e71037064$export$1d04f0e8aa57d594 = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9jl6v.InlineCommentsProvider), null, children);
};

});

parcelRegister("34NZw", function(module, exports) {

$parcel$export(module.exports, "PageShownPublicLinksEventLoader", () => $d52b69b4dbbb4bb4$export$e6747c633274762a);

var $jmjWc = parcelRequire("jmjWc");

const $d52b69b4dbbb4bb4$export$e6747c633274762a = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "UL-jW",
    name: "PageShownPublicLinksEventLoader",
    loader: async ()=>{
        const { PageShownPublicLinksEvent: PageShownPublicLinksEvent } = await (parcelRequire("5pl9w"));
        return PageShownPublicLinksEvent;
    }
});

});
parcelRegister("5pl9w", function(module, exports) {

let $3effb20336e05422$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3effb20336e05422$var$load("63zHi").then(()=>parcelRequire('jvel0'));

});



//# sourceMappingURL=tinyEditorComponentsPreloader.c34d883a.js.map
